import { ComponentRemove } from "./model/ComponentRemove";
var ComponentRemoveStore = new ComponentRemove();
export { ComponentRemoveStore };
